<p-toast></p-toast>
<div class="layout-topbar justify-content-between">
    <a class="app-logo" routerLink="/">
        <!-- <div *ngIf="!schooldetails?.logoUrl" [style.width.rem]="3.5" [style.height.rem]="3.5"
            class="shadow-4 border-circle border-2 border-primary flex-shrink-0 enlarge-on-hover"
            style="background-color: white; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; font-weight: bold; color: #000;">
            {{ getInitials(schooldetails?.name) }}
        </div> -->

        <!-- <img alt="app logo" *ngIf="schooldetails?.logoUrl" [style.width.rem]="3.5" [style.height.rem]="3.5"
            [src]="schooldetails.logoUrl"
            class="shadow-4 border-circle border-2 border-primary flex-shrink-0 enlarge-on-hover"> -->

            <img alt="app logo"  [style.width.rem]="3.5" [style.height.rem]="3.5"
            src="assets/layout/images/wow-care-logo-new.png"
            class="shadow-4 border-circle border-2 border-primary flex-shrink-0 enlarge-on-hover">

        <span class="app-name">
            {{ schooldetails?.name }}<br>
            <span style="margin-left: 0px; font-size: xx-small;">
                SMART CHILDREN | BRIGHT FUTURE
            </span>
        </span>
    </a>


    <button #menubutton class="topbar-menubutton p-link" type="button" (click)="onMenuButtonClick()">
        <span></span>
    </button>

    <div class="topbar-profile">
        <button class="topbar-profile-button p-link" type="button" pStyleClass="@next" enterClass="hidden"
            enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
            <span class="profile-details">
                <span class="profile-job-new">{{schoolData.name || 'School Name'}}</span>
            </span>
            <!-- <i class="pi pi-angle-down"></i> -->
        </button>
    </div>
  
  <!-- Original children-dropdown moved to
       src/app/layout/app.topbar.component.children-backup.html -->
    <ul class="topbar-menu">
        <li *ngFor="let item of tabs; let i = index">
            <a [routerLink]="item.routerLink" routerLinkActive="active-route"
                [routerLinkActiveOptions]="item.routerLinkActiveOptions||{paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored'}"
                [fragment]="item.fragment" [queryParamsHandling]="item.queryParamsHandling"
                [preserveFragment]="item.preserveFragment!" [skipLocationChange]="item.skipLocationChange!"
                [replaceUrl]="item.replaceUrl!" [state]="item.state" [queryParams]="item.queryParams">
                <span>{{item.label}}</span>
            </a>
            <i class="pi pi-times" (click)="removeTab($event, item, i)"></i>
        </li>
        <li *ngIf="!tabs || tabs.length === 0" class="topbar-menu-empty">
            <!-- <h4>Wise Owl Academy</h4> -->
        </li>
    </ul>

    <!-- <div class="topbar-search" [ngClass]="{'topbar-search-active': searchActive}">
        <button class="topbar-searchbutton p-link" type="button" (click)="activateSearch()">
            <i class="pi pi-search"></i>
        </button>

        <div class="search-input-wrapper">
            <span class="p-input-icon-left">
                <input #searchinput type="text" pInputText />
                <i class="pi pi-search" *ngIf="!searchinput.value"></i>
            </span>
        </div>
    </div> -->
    <!-- <div class="topbar-search">
        <div class="topbar-searchbutton p-link">
        </div>
    </div>
    <div class="topbar-search">
        <div class="topbar-searchbutton p-link">
        </div>
    </div> -->
    <!-- <div class="topbar-search">
        <button class="topbar-searchbutton p-link" type="button">
            <i class="wow wow-calEvent"></i>
        </button>

    </div> -->
    
    <!-- SWITCH CHILDREN DROPDOWN (FINAL VERSION) -->
    <!-- Show the active student's name always if there is an active student.
      Only render the dropdown panel when there are other students to switch to.
      Do not show this UI for Staff or Admin users. -->
    <div *ngIf="activeStudent && !(userdata?.refTable === 'Staff' || isAdminUserLogin)" class="custom-dropdown relative mr-3">
      <!-- If there are other children, show a clickable button with chevron; otherwise
           render a non-clickable plain button without chevron. -->
      <button *ngIf="withoutActiveStudent.length > 0" type="button" class="topbar-searchbutton p-link custom-dropdown-button" (click)="toggleChildrenDropdown()">
        {{ this.activeStudent.fullName }}
        <i class="pi pi-chevron-down ml-2"></i>
      </button>
      <button *ngIf="!withoutActiveStudent.length" type="button" class="topbar-searchbutton p-link custom-dropdown-button" disabled>
        {{ this.activeStudent.fullName }}
      </button>

      <div *ngIf="isChildrenDropdownOpen && withoutActiveStudent.length > 0" class="custom-dropdown-panel" style="max-height: 50vh; max-height: 50dvh; overflow-y: auto;">
        <div *ngIf="withoutActiveStudent.length > 0">
          <div *ngFor="let student of withoutActiveStudent">
            <a pRipple
              class="flex p-2 border-round align-items-center hover:sure transition-colors transition-duration-150 cursor-pointer mb-1"
              (click)="studentProfileChange(student)">
              <div class="flex mt-1 block">
                <img *ngIf="student.profileimg != undefined; else noImageFound"
                  [src]="student.profileimg" width="43" height="43" alt="profile"
                  class="border-circle border-2 border-primary flex-shrink-0 shadow-4" />
                <ng-template #noImageFound>
                  <img src="assets/layout/images/male.png" alt="Fallbackimage" width="43" height="43"
                    class="border-circle border-2 border-primary flex-shrink-0 shadow-4" />
                </ng-template>
                <div class="ml-2 mt-1">
                  <div class="text-base font-bold text-900 mb-0 flex flex-column">
                    <span class="text-primary">{{student.fullName}}</span>
                    <!-- <span class="text-primary cursor-none">{{ getRoomName(student.roomId) }}</span> -->
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Chat icon with badge -->
<!-- Message icon -->
    <div class="topbar-search">
      <button (click)="openCommunication()" class="topbar-searchbutton p-link" type="button">
        <i class="wow wow-chat"></i>
        <span class="button__badge" *ngIf="messageCount && messageCount > 0">
          {{ messageCount > 99 ? '99+' : messageCount}}
        </span>
      </button>
    </div>
    <div class="topbar-search">
      <button (click)="showBellNotificationDialog()" class="topbar-searchbutton p-link" type="button">
        <i class="wow wow-bell"></i>
        <span class="button__badge" *ngIf="notificationsCount && notificationsCount > 0">
          {{ notificationsCount > 99 ? '99+' : notificationsCount }}
        </span>
      </button>
    </div>
      
      
    <div class="topbar-profile">
        <button class="topbar-profile-button p-link" type="button" pStyleClass="@next" enterClass="hidden"
            enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
            <span *ngIf="this.userdata.refTable === 'Staff'; else guardianPicture">
                <img [src]="picture" *ngIf="picture != undefined; else noImageFound"
                    class="shadow-4 border-circle border-2 border-primary flex-shrink-0 mr-2 enlarge-on-hover"
                    [style.width.rem]="3.5" [style.height.rem]="3.5" height="10" width="10" />
                <!-- <ng-template #noImageFound>
                    <img src="assets/layout/images/male.png"
                        class="shadow-4 border-circle border-2 border-primary flex-shrink-0 mr-2 enlarge-on-hover"
                        [style.width.rem]="3.5" [style.height.rem]="3.5" height="10" width="10" />
                </ng-template> -->
                <ng-template #noImageFound>
                  <div class="circle flex justify-content-center align-items-center mr-1"
                      [style.background-color]="getBackgroundColor(userdata.refTableId)" >
                      {{ getInitials(userdata.firstName) }}
                  </div>
              </ng-template>
            </span>
            <ng-template #guardianPicture>
              <img [src]="picture" *ngIf="picture != undefined; else noImageFound1"
              class="shadow-4 border-circle border-2 border-primary flex-shrink-0 mr-2 enlarge-on-hover"
              [style.width.rem]="3.5" [style.height.rem]="3.5" height="10" width="10" />
               
                  <ng-template #noImageFound1>
                    <div class="circle flex justify-content-center align-items-center mr-1"
                        [style.background-color]="getBackgroundColor(userdata.refTableId)" >
                        {{ getInitials(userdata.firstName) }}
                    </div>
                </ng-template>
            </ng-template>

            <span class="profile-details">
                <span class="profile-job-new">{{userdata.firstName}}</span>
                <span class="profile-job">{{this.userdata.refTable != 'Staff' ? this.studentRelation : this.userRole}}
                    <span class="profile-job"
                        *ngIf="this.userdata.refTable == 'Guardian' && this.activeStudent">({{this.activeStudent.fullName}})</span>
                </span>
            </span>
            <i class="pi pi-angle-down"></i>
        </button>
    <ul #profileMenu
      class="list-none p-3 m-0 border-round shadow-2 hidden absolute surface-card  origin-top w-20rem sm:w-18rem mt-2 right-0 top-auto">
            <!-- <span *ngIf="isAdditionalAccount || withoutActiveStudent.length" class="text-base font-medium">Switch
                to</span> -->
            <li>
              
                <div pRipple
                    class="flex p-2 border-round align-items-center hover:surface-200 transition-colors transition-duration-150 cursor-pointer mt-1"
                    (click)="goToUserProfile()">
                    <i class="wow wow-account-circle mr-3" style="color: #573353;"></i>
                    <span class="text-primary">My Profile</span>
                </div>
                <div pRipple
                    class="flex p-2 border-round align-items-center  transition-colors transition-duration-150 cursor-none mt-1">
                    <i class="wow wow-top_key mr-3" style="color: #573353;"></i>
                    <span class="text-primary">
                        Sign-in pin :
                        {{ userdata?.refTable === 'Guardian' ? guardianData?.signInPin ?? 'No Clock In Pin' : loginPin ?? 'No Clock In Pin' }}
                    </span>
                      
                </div> 
                <div pRipple
                    class="flex p-2 border-round align-items-center  hover:surface-200 transition-colors transition-duration-150 cursor-pointer mt-1"
                    (click)="onChangePassword()">
                    <i class="wow wow-top_lock mr-3" style="color: #573353;"></i>
                    <span class="text-primary">Change Password</span>
                </div> 
                <div
                pRipple
                class="flex p-2 border-round align-items-center hover:surface-200 transition-colors transition-duration-150 cursor-pointer mt-1"
                (click)="openHelpLink()">
                <i class="wow wow-help_circle mr-3" style="color: #573353;"></i>
                <span class="text-primary">Help</span>
              </div>              
                <div pRipple
                    class="flex p-2 border-round align-items-center  hover:surface-200 transition-colors transition-duration-150 cursor-pointer"
                    (click)="showLogoutDialog = true">
                    <i class="wow wow-logout off mr-3" style="color: #573353;"></i>
                    <span class="text-primary">Logout</span>
                </div>

            </li>
        </ul>
    </div>
</div>

<!------Change Password-->
<p-dialog
  [(visible)]="showChangePasswordDialog"
  header="Change Password"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '400px' }"
  [contentStyle]="{ 'text-align': 'center' }"
>
  <!-- Icon -->
  <div class="mb-3 mt-2">
    <i class="pi pi-lock text-4xl text-primary"></i>
  </div>

  <!-- Title -->
  <div class="text-xl font-semibold mb-2">Change Password</div>

  <!-- Description -->
  <div class="text-sm text-color-secondary mb-4">
    Are you sure you want to change your password? A password reset link will be sent to your registered email.
  </div>

  <!-- Buttons -->
  <div class="flex justify-content-center gap-3 mt-3">
    <button
      pButton
      label="Cancel"
      class="p-button-outlined"
      (click)="showChangePasswordDialog = false"
    ></button>
    <button
      pButton
      label="Yes, Change Password"
      class="add-custom"
      [loading]="changePasswordLoading"
      (click)="onConfirmChangePassword()"
    ></button>
  </div>
</p-dialog>

<!------Change Password-->

<p-dialog
  [(visible)]="showLogoutDialog"
  header="Logout"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '350px' }"
  [contentStyle]="{ 'text-align': 'center' }"
  [breakpoints]="{ '960px': '80vw' }"
>
  <!-- Icon at top -->
  <div class="mb-3 mt-3">
    <i class="wow wow-logout_child text-4xl text-primary" style="height: 95px;width: 150px;"></i>
  </div>

  <!-- Text -->
  <div class="mb-3 text-sm font-semibold">Are you sure you want to log out?</div>

  <!-- Buttons -->
  <div class="flex justify-content-center gap-3 mt-4">
    <button
      pButton
      type="button"
      label="No"
      style="width: 30%;"
      class="p-button-outlined"
      (click)="showLogoutDialog = false"
    ></button>
    <button
      pButton
      label="Yes"
      style="width: 30%;"
      class="add-custom"
      (click)="confirmLogout()"
    ></button>
  </div>
</p-dialog>



<!---------Notifications Dialog--------->

<style>
    .button__badge {
    background-color: #fa3e3e;
    border-radius: 25px;
    color: white;
    padding: 1px 5px;
    font-size: 10px;
    position: relative;
    top: -10px;
    right: 8px;
}

:host ::ng-deep .p-button.p-button-outlined {
    background: transparent;
    color: #6b7bf9;
    border: 1px solid;
  }

  .custom-dropdown {
  position: relative;

  .custom-dropdown-button {
    padding: 0.5rem 1rem;
    border-radius: 1.5rem;
    background-color: var(--surface-0);
    border: 1px solid var(--surface-border);
    color: var(--text-color);
    font-weight: 500;
    display: flex;
    align-items: center;
  }

  .custom-dropdown-panel {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 16rem;
    background: #ffff;
    border-radius: 0.5rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    z-index: 100;
    margin-top: 0.5rem;
    padding: 0.5rem;
    border: 1px solid var(--surface-overlay);

  }
}

.circle {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  flex-shrink: 0;
}

</style>